import { ContingencyPlanDTO, ContingencyPlanListResponse } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'
import { getQueryParams } from 'utils/getQueryParams'

type UseContingencyPlansListProps = {
  residentID: string | undefined
}

type UseContingencyPlansListReturn = {
  contingencyPlans: ContingencyPlanDTO[] | []
  isLoading: boolean
}

const CONTINGENCY_URL = '/api/list/contingency-plans'

const useContingencyPlansList = ({
  residentID,
}: UseContingencyPlansListProps): UseContingencyPlansListReturn => {
  const params = getQueryParams({ resident: residentID })
  const { data, isLoading } = useQuery<ContingencyPlanListResponse>(
    ['contingencyPlans', params],
    () => getJSON({ url: `${CONTINGENCY_URL}?${params}` })
  )

  const contingencyPlans = data?.data

  return {
    contingencyPlans: contingencyPlans || [],
    isLoading,
  }
}

export default useContingencyPlansList
